import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { filter, Subject, takeUntil } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { UserSerivice } from "src/app/services/user.service";

@Component({
  selector: "app-account-profile",
  templateUrl: "./account-profile.component.html",
  styleUrls: ["./account-profile.component.css"],
})
export class AccountProfileComponent implements OnInit, OnDestroy {
  constructor(
    private userService: UserSerivice,
    private toastrService: ToastrService
  ) {}

  private __destroy$ = new Subject();

  ngOnDestroy(): void {
    this.__destroy$.complete();
  }

  profileForm = new FormGroup({
    fullName: new FormControl(""),
    email: new FormControl(""),
    phone: new FormControl(""),
    mobile: new FormControl(""),
  });

  ngOnInit(): void {
    this.userService
      .currentProfile()
      .pipe(takeUntil(this.__destroy$))
      .pipe(filter((d) => !!d))
      .subscribe((d) =>
        this.profileForm.setValue({
          fullName: d.name,
          email: d.email,
          phone: d.phone,
          mobile: d.mobile,
        })
      );
  }

  private notifyProfileSaved() {
    this.toastrService.success("Your account details have been updated.")
  }

  save() {
    const {
      value: { phone = "", mobile = "" },
    } = this.profileForm;

    this.userService
      .updateProfile({ phone: phone?.trim(), mobile: mobile?.trim() })
      .pipe(takeUntil(this.__destroy$))
      .subscribe(() => this.toastrService.success("Your profile has been updated.")
    );
  }
}
